import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../lib/queryClient";
import { mediaService, MediaAsset } from "../../services/mediaService";

/**
 * Query hook for media library assets
 */
export const useMediaQuery = (params?: { media_type?: string; search?: string }) => {
  return useQuery<MediaAsset[]>({
    queryKey: queryKeys.media.list(params),
    queryFn: ({ signal }) => mediaService.getMediaAssets(params, signal),
  });
};

/**
 * Mutation hook to create a media asset
 */
export const useCreateMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: FormData | Partial<MediaAsset>) => mediaService.createMediaAsset(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.media.all });
    },
  });
};

/**
 * Mutation hook to update a media asset
 */
export const useUpdateMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: FormData | Partial<MediaAsset> }) =>
      mediaService.updateMediaAsset(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.media.all });
    },
  });
};

/**
 * Mutation hook to delete a media asset
 */
export const useDeleteMediaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => mediaService.deleteMediaAsset(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.media.all });
    },
  });
};
